/* Colour Pop Kit "how it works" — click a step, swap the stage photo/video.
   All markup + copy is server-rendered by sections/kkumi-cpk-how-it-works.liquid;
   this only flips aria-pressed on the steps and .is-active on the stage shots,
   and plays the active shot's video (muted loop) while the section is on screen.
   Every step's <video> is rendered up front, stacked in one stage — src never swaps.
   Loading is staggered one step ahead: step 1 buffers on page load (preload="auto"),
   step 2 starts once step 1 can play through, and selecting step N queues N and N+1.
   Native controls are NOT rendered (iOS flashes them every time a controlled video
   starts); a tap on the stage plays a paused video and, if the section's controls
   setting is on (data-kk-hiw-controls), reveals controls on that video until the
   step changes. A shopper's pause / unmute is respected. Autoplay can be turned off
   (data-kk-hiw-manual). Reduced motion: no autoplay on the storefront; tap still plays. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  // In the theme editor, play regardless so a merchant with reduced motion on can
  // still check the video they just picked. Shoppers' preference is always honoured.
  function reducedMotion() {
    if (window.Shopify && window.Shopify.designMode) return false;
    return !!(reduceMotion && reduceMotion.matches);
  }

  function bind(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';

    var steps = root.querySelectorAll('[data-kk-hiw-step]');
    var shots = root.querySelectorAll('[data-kk-hiw-shot]');
    var inView = !('IntersectionObserver' in window);

    var autoplay = !root.hasAttribute('data-kk-hiw-manual');
    var videos = root.querySelectorAll('[data-kk-hiw-video]');

    // Autoplay is only allowed while muted. The `muted` attribute alone isn't always
    // reflected onto the property (e.g. markup swapped in by the theme editor), so set
    // it once up front; after that a shopper's unmute via the controls sticks.
    videos.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      // Tell our own pauses apart from the shopper's (native controls), so a video they
      // paused isn't restarted when the section scrolls back into view.
      v.addEventListener('pause', function () {
        if (v._kkAutoPause) v._kkAutoPause = false;
        else v._kkUserPaused = true;
      });
      v.addEventListener('play', function () {
        v._kkUserPaused = false;
        if (v._kkAutoPlay) v._kkAutoPlay = false;
        else v._kkUserPlayed = true; // shopper pressed play: keep it going even without autoplay
      });
    });

    var allowControls = root.hasAttribute('data-kk-hiw-controls');

    // Staggered buffering: start fetching a video (once). preload="none" videos only
    // download after preload flips to auto and load() is called; load() on a video that
    // is already buffering/playing would restart it, hence the guard.
    function videoAt(i) {
      var f = shots[i];
      return f ? f.querySelector('[data-kk-hiw-video]') : null;
    }
    function queue(i) {
      var v = videoAt(i);
      if (!v || v._kkQueued) return;
      v._kkQueued = true;
      v.preload = 'auto';
      // Step 1 may already be fetching from its markup preload; iOS often ignores preload
      // until load() is called, so only kick it when nothing is loading yet.
      if (v.readyState > 0 || v.networkState === 2 /* NETWORK_LOADING */) return;
      v.load();
    }
    // Load i now, then i+1 once i can play through (so the step on screen gets the bandwidth first).
    function queueFrom(i) {
      i = Number(i);
      queue(i);
      var v = videoAt(i);
      var next = function () { queue(i + 1); };
      if (!v || v.readyState >= 4) next();
      else {
        v.addEventListener('canplaythrough', next, { once: true });
        // iOS can sit at HAVE_FUTURE_DATA with preload; don't let that stall the next step forever.
        v.addEventListener('loadeddata', function () { setTimeout(next, 1500); }, { once: true });
        v.addEventListener('error', next, { once: true }); // a broken file mustn't block the next step
      }
    }

    function hideControls(v) {
      if (!v || !v.controls) return;
      v.controls = false;
      v.classList.remove('is-controls');
    }

    function wantsPlay(f, v) {
      if (!f.classList.contains('is-active') || !inView || v._kkUserPaused) return false;
      if (v._kkUserPlayed) return true;
      return autoplay && !reducedMotion();
    }

    function play(f, v) {
      v._kkAutoPlay = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        v._kkAutoPlay = false; // no play event fired; don't mislabel the shopper's next play
        // Not enough data yet (preload="none" step just selected): retry once it can play.
        v.addEventListener('canplay', function () {
          if (wantsPlay(f, v) && v.paused) {
            v._kkAutoPlay = true;
            var q = v.play();
            if (q && q.catch) q.catch(function () { v._kkAutoPlay = false; });
          }
        }, { once: true });
      });
    }

    function syncVideos() {
      shots.forEach(function (f) {
        var v = f.querySelector('[data-kk-hiw-video]');
        if (!v) return;
        if (wantsPlay(f, v)) {
          if (v.paused) play(f, v);
        } else if (!v.paused) {
          v._kkAutoPause = true;
          v.pause();
        }
      });
    }

    function show(i) {
      steps.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.kkHiwStep === String(i) ? 'true' : 'false');
      });
      shots.forEach(function (f) {
        var on = f.dataset.kkHiwShot === String(i);
        var v = f.querySelector('[data-kk-hiw-video]');
        if (v && on !== f.classList.contains('is-active')) {
          // Freshly selected (or deselected): start from 0, drop any revealed controls and
          // forget earlier pause state.
          v._kkUserPaused = false;
          v._kkUserPlayed = false;
          hideControls(v);
          if (!on && !v.paused) { v._kkAutoPause = true; v.pause(); }
          try { v.currentTime = 0; } catch (e) {}
        }
        f.classList.toggle('is-active', on);
        if (on) f.removeAttribute('aria-hidden');
        else f.setAttribute('aria-hidden', 'true');
      });
      queueFrom(i);
      syncVideos();
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kk-hiw-step]');
      if (btn && root.contains(btn)) { show(btn.dataset.kkHiwStep); return; }

      // Tap on the stage (the video itself has pointer-events: none until controls are
      // revealed). A tap is a user gesture, so play() works even where autoplay is blocked
      // (iOS Low Power Mode, reduced motion).
      var f = e.target.closest('[data-kk-hiw-shot]');
      if (!f || !root.contains(f) || !f.classList.contains('is-active')) return;
      var v = f.querySelector('[data-kk-hiw-video]');
      if (!v || v.controls) return;
      if (v.paused) {
        var p = v.play(); // play event marks this as the shopper's play
        if (p && p.catch) p.catch(function () {});
      } else if (!allowControls) {
        v.pause(); // no controls to pause with: the tap toggles
      }
      if (allowControls) {
        v.controls = true;
        v.classList.add('is-controls');
      }
    });

    // Theme editor: selecting a step block previews its photo/video.
    root.addEventListener('shopify:block:select', function (e) {
      var btn = e.target.querySelector && e.target.querySelector('[data-kk-hiw-step]');
      if (btn) show(btn.dataset.kkHiwStep);
    });

    if (videos.length) {
      queueFrom(0); // step 1 is buffering from markup (preload="auto"); line up step 2 behind it
      if (!('IntersectionObserver' in window)) {
        syncVideos(); // no observer: inView is already true, just play
      } else {
        new IntersectionObserver(function (entries) {
          inView = entries[entries.length - 1].isIntersecting;
          syncVideos();
        }, { threshold: 0.25 }).observe(root);
      }
      if (reduceMotion && reduceMotion.addEventListener) reduceMotion.addEventListener('change', syncVideos);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-kk-hiw]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
